// Import all config files statically
import { config as ankaraConfig } from './config.ankara';
import { config as automationConfig } from './config.automation';
import { config as devConfig } from './config.dev';
import { config as developmentConfig } from './config.development';
import { config as germanyConfig } from './config.germany';
import { config as intConfig } from './config.int';
import { Config } from './config.model';
import { config as productionConfig } from './config.production';
import { config as sandboxConfig } from './config.sandbox';
import { config as stagingConfig } from './config.staging';
import { config as tuzla01Config } from './config.tuzla01';
import { config as unitedkingdomConfig } from './config.unitedkingdom';

// Environment mapping
const domainEnvMapping = {
  localhost: 'development',
  'maestro-dev.oplog.app': 'dev',
  'maestro-int.oplog.app': 'int',
  'maestro-automation.oplog.app': 'automation',
  'maestro-staging.oplog.app': 'staging',
  'maestro-sandbox.oplog.app': 'sandbox',
  'maestro.oplog.app': 'production',
  'maestro-tuzla-01.oplog.app': 'tuzla01',
  'maestro-ankara.oplog.app': 'ankara',
  'maestro-uk.oplog.app': 'unitedkingdom',
  'maestro-germany.oplog.app': 'germany',
};

// Config mapping
const configMapping = {
  development: developmentConfig,
  dev: devConfig,
  int: intConfig,
  automation: automationConfig,
  staging: stagingConfig,
  sandbox: sandboxConfig,
  production: productionConfig,
  tuzla01: tuzla01Config,
  ankara: ankaraConfig,
  unitedkingdom: unitedkingdomConfig,
  germany: germanyConfig,
};

// Determine environment
const domain = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const env = domainEnvMapping[domain] || 'development';

// Get the appropriate config
const envConfig = configMapping[env] || developmentConfig;

// Merge default config with environment-specific config and derived flags
export const config: Config = {
  ...envConfig,
  env,
  isDev: env === 'development',
  isInt: env === 'int',
  isAutomation: env === 'automation',
  isStaging: env === 'staging',
  isSandbox: env === 'sandbox',
  isProduction: env === 'production',
  isTuzla01: env === 'tuzla01',
  isAnkara: env === 'ankara',
  isUnitedKingdom: env === 'unitedkingdom',
  isGermany: env === 'germany',
  i18n: {
    default: 'tr-TR',
    locales: ['tr-TR', 'en-US'],
  },
};

const liveEnvs = ['production', 'tuzla01', 'ankara', 'unitedkingdom', 'germany'];
export const isBarcodeDebuggingEnabled = !liveEnvs.includes(env) && env !== 'staging';
